import * as services from "../service/services";
import * as types from "./mutation-types";

/* eslint-disable */
export default {
  changeTitle({ commit }, payload) {
    commit(types.CHANGE_TITLE, payload);
  },

  getConfig({ commit }) {
    axios
      .get(services.GET_CONFIG)
      .then(resp => {
        commit(types.LOAD_CONFIG, { data: resp.data.dataConfig });
      })
      .catch(err => {});
  },

  setLoader({ commit }, payload) {
      commit(types.SET_LOADER, payload);
  },

  setLocale({ commit }, payload) {
      commit(types.SET_LOCALE, payload);
  },
};
